var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TransferOperation
 * @author zhuwanying02, zhanghao14
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash-es';

import { classPrefix } from '../../common/util';

import './Transfer.less';

var TransferOperation = function (_Component) {
    _inherits(TransferOperation, _Component);

    function TransferOperation() {
        _classCallCheck(this, TransferOperation);

        return _possibleConstructorReturn(this, (TransferOperation.__proto__ || Object.getPrototypeOf(TransferOperation)).apply(this, arguments));
    }

    _createClass(TransferOperation, [{
        key: 'operateSelectedData',
        value: function operateSelectedData(direction) {
            var handleSelectedData = this.props.handleSelectedData;
            if (handleSelectedData && isFunction(handleSelectedData)) {
                handleSelectedData(direction);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                isLeftArrowClickable = _props.isLeftArrowClickable,
                isRightArrowClickable = _props.isRightArrowClickable;

            var prefixCls = classPrefix + '-transfer-operation';
            var leftArrowClass = classnames((_classnames = {}, _defineProperty(_classnames, prefixCls + '-arrow', true), _defineProperty(_classnames, prefixCls + '-arrow-selected', isLeftArrowClickable), _classnames));
            var rightArrowClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls + '-arrow', true), _defineProperty(_classnames2, prefixCls + '-arrow-selected', isRightArrowClickable), _classnames2));
            return React.createElement(
                'div',
                { className: prefixCls },
                React.createElement(
                    'div',
                    { className: leftArrowClass,
                        onClick: this.operateSelectedData.bind(this, 'toSource') },
                    React.createElement('span', { className: prefixCls + '-left' })
                ),
                React.createElement(
                    'div',
                    { className: rightArrowClass,
                        onClick: this.operateSelectedData.bind(this, 'toTarget') },
                    React.createElement('span', { className: prefixCls + '-right' })
                )
            );
        }
    }]);

    return TransferOperation;
}(Component);

TransferOperation.defaultProps = {
    classPrefix: classPrefix
};
TransferOperation.propTypes = {
    handleSelectedData: PropTypes.func.isRequired,
    isLeftArrowClickable: PropTypes.bool,
    isRightArrowClickable: PropTypes.bool,
    classPrefix: PropTypes.string
};
export default TransferOperation;